export var InsightsInterval;
(function (InsightsInterval) {
    InsightsInterval["Day"] = "day";
    InsightsInterval["Week"] = "week";
    InsightsInterval["Month"] = "month";
    InsightsInterval["Quarter"] = "quarter";
    InsightsInterval["Year"] = "year";
})(InsightsInterval || (InsightsInterval = {}));
export var InsightsMetric;
(function (InsightsMetric) {
    InsightsMetric["Cpa"] = "cpa";
    InsightsMetric["Roas"] = "roas";
    InsightsMetric["Ctr"] = "ctr";
    InsightsMetric["Cpc"] = "cpc";
    InsightsMetric["Cpm"] = "cpm";
    InsightsMetric["Cvr"] = "cvr";
    InsightsMetric["Spend"] = "spend";
})(InsightsMetric || (InsightsMetric = {}));
